module.exports = __webpack_public_path__ + "img/happy-doctor-holding-clipboard-with-patients.6befba1c.png";